(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["base-contract-fe-app"] = factory();
	else
		root["base-contract-fe-app"] = factory();
})(window, function() {
return 